import axios from "axios";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BASE_URL, ENVIRONMENT } from "../../config";
import { dispPrice, getWord } from "../../utils/functions";
import { LoadingDiv } from "./Loading";

const Canvas = ({ isOpen, children }) => {
  if (!isOpen) return null;

  return <div className={`canvas ${isOpen ? "open" : ""}`}>{children}</div>;
};
const SearchPop = () => {
  const [isCanvasOpen, setIsCanvasOpen] = useState(false);
  const [query, setQuery] = useState("");
  const [debouncedQuery, setDebouncedQuery] = useState("");
  const [data, setData] = useState({ products: "" });
  const [loading, setLoading] = useState(false);

  // Debounce logic
  useEffect(() => {
    setLoading(true);
    const handler = setTimeout(() => {
      setDebouncedQuery(query);
    }, 1000); // 1 seconds
    return () => clearTimeout(handler);
  }, [query]);

  useEffect(() => {
    if (debouncedQuery) {
      getData();
    } else {
      setLoading(false);
      setData({ products: "" });
    }
  }, [debouncedQuery]);

  const getData = async () => {
    await axios
      .get(`${BASE_URL}/products/search/${debouncedQuery}`)
      .then((response) => {
        setData({ ...data, products: response.data });
        setLoading(false);
        // console.log(data.products);
      })
      .catch((error) => {
        if (ENVIRONMENT === "development") {
          console.log(error);
        }
      });
  };

  const handleClose = () => {
    setQuery("");
    setDebouncedQuery("");
    setIsCanvasOpen(false);
    setData({ products: "" });
  };

  return (
    <li className="nav-search">
      <button className="nav-icon-item" onClick={() => setIsCanvasOpen(true)}>
        <i className="icon icon-search"></i>
      </button>

      <Canvas isOpen={isCanvasOpen} onClose={() => setIsCanvasOpen(false)}>
        <div className="canvas-search">
          <div className="canvas-wrapper">
            <header className="tf-search-head">
              <div className="title fw-5">
                {getWord("Search Product")}
                <div className="close" onClick={handleClose}>
                  <span
                    className="icon-close icon-close-popup"
                    data-bs-dismiss="offcanvas"
                    aria-label="Close"
                  ></span>
                </div>
              </div>
              <div className="tf-search-sticky">
                <div className="tf-mini-search-frm">
                  <fieldset className="text">
                    <input
                      type="text"
                      placeholder="Search"
                      tabIndex="0"
                      onChange={(e) => setQuery(e.target.value)}
                      value={query}
                    />
                  </fieldset>
                  <button type="button">
                    <i className="icon-search"></i>
                  </button>
                </div>
              </div>
            </header>
            <div className="canvas-body p-0">
              <div className="tf-search-content">
                <div className="tf-cart-hide-has-results">
                  <div className="tf-col-content">
                    <div className="tf-search-hidden-inner">
                      {loading ? (
                        <LoadingDiv />
                      ) : data.products.length > 0 ? (
                        <>
                          {data.products.map((item, index) => (
                            <div className="tf-loop-item" key={index}>
                              <div className="image">
                                <Link
                                  to={"/product/" + item.slug}
                                  onClick={handleClose}
                                >
                                  <img src={item.image} alt="" />
                                </Link>
                              </div>
                              <div className="content">
                                <Link
                                  to={"/product/" + item.slug}
                                  onClick={handleClose}
                                >
                                  {item.title}
                                </Link>
                                <div className="tf-product-info-price">
                                  {item.discount > 0 ? (
                                    <>
                                      <div className="compare-at-price">
                                        {dispPrice(item.price)}
                                      </div>
                                      <div className="price-on-sale fw-6">
                                        {dispPrice(item.discount)}
                                      </div>
                                    </>
                                  ) : (
                                    <div className="price-on-sale fw-6">
                                      {dispPrice(item.price)}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          ))}
                        </>
                      ) : (
                        <div className="text-center">
                          {getWord("No Products")}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Canvas>
    </li>
  );
};

export default SearchPop;
